import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'app/components/components.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { Helper } from 'app/utilities/helper';
import { HttpModule } from '@angular/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { ServicesModule } from './services/services.module';
import { TranslatePipe } from './pipes/translate.pipe';
import { CustomPreloadingStrategy } from './utilities/custom-preloading-strategy';
import { PageNotFoundModule } from './pages/page-not-found-module/page-not-found-module.module';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { DialogSpecialDayComponent } from './components/modal/dialog-special-day/dialog-special-day.component';
import { TranslateSingularPluralPipe } from './pipes/translate-singular-plural.pipe';
import { SafeHTMLPipe } from './pipes/safeHTML.pipe';
import * as Raven from 'raven-js';

import { envName, sentryKey } from '../environments/properties';
import { ConvertExchangePipe } from './pipes/convert-exchange.pipe';


Raven
  .config(sentryKey)
  .install();

Raven.setEnvironment(envName);

export class RavenErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    if (envName as string !== 'local') {
      Raven.captureException(err);
    }
    console.error(err);
  }
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    ServicesModule,
    AppRoutingModule,
    PageNotFoundModule,
  ],
  entryComponents: [
    TermsAndConditionsComponent,
    DialogSpecialDayComponent,
  ],
  providers: [
    Helper,
    TranslatePipe,
    ConvertExchangePipe,
    CustomPreloadingStrategy,
    TranslateSingularPluralPipe,
    SafeHTMLPipe,
    { provide: ErrorHandler, useClass: RavenErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts